const grid = {
  // Form
  'cols-12': `
  <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="33.5" height="20.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'cols-6-6': `
  <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="15.5" height="20.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="18.75" y="0.75" width="15.5" height="20.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'cols-4-4-4': `
  <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10.25" y="21.25" width="9.5" height="20.5" rx="1.25" transform="rotate(-180 10.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    <rect x="22.25" y="21.25" width="9.5" height="20.5" rx="1.25" transform="rotate(-180 22.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    <rect x="34.25" y="21.25" width="9.5" height="20.5" rx="1.25" transform="rotate(-180 34.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'cols-3-3-3-3': `
    <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="7.25" y="21.25" width="6.5" height="20.5" rx="1.25" transform="rotate(-180 7.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="16.25" y="21.25" width="6.5" height="20.5" rx="1.25" transform="rotate(-180 16.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="25.25" y="21.25" width="6.5" height="20.5" rx="1.25" transform="rotate(-180 25.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="34.25" y="21.25" width="6.5" height="20.5" rx="1.25" transform="rotate(-180 34.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    </svg>
  `,
  'cols-2-2-2-2-2-2': `
    <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 4.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="10.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 10.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="16.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 16.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="22.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 22.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="28.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 28.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="34.25" y="21.25" width="3.5" height="20.5" rx="1.25" transform="rotate(-180 34.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    </svg>
  `,
  'cols-9-3': `
  <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="22.5" height="20.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="25.75" y="0.75" width="7.5" height="20.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'cols-3-9': `
  <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="33.25" y="21.25" width="22.5" height="20.5" rx="1.25" transform="rotate(-180 33.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    <rect x="8.25" y="21.25" width="7.5" height="20.5" rx="1.25" transform="rotate(-180 8.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'rows-12': `
  <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="33.5" height="9.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="0.75" y="12.75" width="33.5" height="8.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'rows-6-6': `
  <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="15.5" height="9.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="0.75" y="12.75" width="15.5" height="8.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="18.75" y="0.75" width="15.5" height="9.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
    <rect x="18.75" y="12.75" width="15.5" height="8.5" rx="1.25" stroke="#32313E" stroke-width="1.5"/>
  </svg>
  `,
  'rows-4-4-4': `
    <svg width="35" height="22" viewBox="0 0 35 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10.25" y="10.25" width="9.5" height="9.5" rx="1.25" transform="rotate(-180 10.25 10.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="10.25" y="21.25" width="9.5" height="8.5" rx="1.25" transform="rotate(-180 10.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="22.25" y="10.25" width="9.5" height="9.5" rx="1.25" transform="rotate(-180 22.25 10.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="22.25" y="21.25" width="9.5" height="8.5" rx="1.25" transform="rotate(-180 22.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="34.25" y="10.25" width="9.5" height="9.5" rx="1.25" transform="rotate(-180 34.25 10.25)" stroke="#32313E" stroke-width="1.5"/>
      <rect x="34.25" y="21.25" width="9.5" height="8.5" rx="1.25" transform="rotate(-180 34.25 21.25)" stroke="#32313E" stroke-width="1.5"/>
    </svg>
  `,
  // New icons
  'one-col': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4Z" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'two-cols': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H12M12 3H3.6C3.26863 3 3 3.26863 3 3.6V20.4C3 20.7314 3.26863 21 3.6 21H12M12 3V21" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'three-cols': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3H3.6C3.26863 3 3 3.26863 3 3.6V20.4C3 20.7314 3.26863 21 3.6 21H9M9 3V21M9 3H15M9 21H15M15 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H15M15 3V21" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'four-cols': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21L12 16.5L12 12L12 7.5L12 3M12 21L16.5 21M12 21L7.5 21M12 3L16.5 3M12 3L7.5 3M16.5 21L20.4 21C20.7314 21 21 20.7314 21 20.4L21 16.5L21 12L21 7.5L21 3.6C21 3.26863 20.7314 3 20.4 3L16.5 3M16.5 21L16.5 16.5L16.5 12L16.5 7.5L16.5 3M7.5 3L3.6 3C3.26863 3 3 3.26863 3 3.6L3 7.5L3 12L3 16.5L3 20.4C3 20.7314 3.26863 21 3.6 21L7.5 21M7.5 3L7.5 7.5L7.5 12L7.5 16.5L7.5 21" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'six-cols': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 16.5L3 12L3 7.5L3 3.6C3 3.26863 3.26863 3 3.6 3L20.4 3C20.7314 3 21 3.26863 21 3.6L21 7.5L21 12L21 16.5L21 20.4C21 20.7314 20.7314 21 20.4 21L3.6 21C3.26863 21 3 20.7314 3 20.4L3 16.5Z" stroke="black" stroke-width="1.3"/>
      <path d="M6 3V21.5" stroke="black" stroke-width="1.3"/>
      <path d="M9 3V21.5" stroke="black" stroke-width="1.3"/>
      <path d="M12 3V21.5" stroke="black" stroke-width="1.3"/>
      <path d="M15 3V21.5" stroke="black" stroke-width="1.3"/>
      <path d="M18 3V21.5" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'two-cols-start-small': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 3L3.6 3C3.26863 3 3 3.26863 3 3.6L3 7.5L3 12L3 16.5L3 20.4C3 20.7314 3.26863 21 3.6 21L7.5 21M7.5 3L7.5 7.5L7.5 12L7.5 16.5L7.5 21M7.5 3L20.4 3C20.7314 3 21 3.26863 21 3.6L21 7.5L21 12L21 16.5L21 20.4C21 20.7314 20.7314 21 20.4 21L7.5 21" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'two-cols-end-small': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5 21L20.4 21C20.7314 21 21 20.7314 21 20.4L21 16.5L21 12L21 7.5L21 3.6C21 3.26863 20.7314 3 20.4 3L16.5 3M16.5 21L16.5 16.5L16.5 12L16.5 7.5L16.5 3M16.5 21L3.6 21C3.26863 21 3 20.7314 3 20.4L3 16.5L3 12L3 7.5L3 3.6C3 3.26863 3.26863 3 3.6 3L16.5 3" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'two-cols-vertical': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 3.6V12H12V3H20.4C20.7314 3 21 3.26863 21 3.6Z" stroke="black" stroke-width="1.3"/>
      <path d="M21 20.4V12H12V21H20.4C20.7314 21 21 20.7314 21 20.4Z" stroke="black" stroke-width="1.3"/>
      <path d="M3 12V3.6C3 3.26863 3.26863 3 3.6 3H12V12H3Z" stroke="black" stroke-width="1.3"/>
      <path d="M3 12V20.4C3 20.7314 3.26863 21 3.6 21H12V12H3Z" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
  'three-cols-vertical': `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3H3.6C3.26863 3 3 3.26863 3 3.6V20.4C3 20.7314 3.26863 21 3.6 21H9M9 3V21M9 3H15M9 21H15M15 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H15M15 3V21" stroke="black" stroke-width="1.3"/>
      <path d="M3 12L21 12" stroke="black" stroke-width="1.3"/>
    </svg>
  `,
};

export default grid;
